var _path, _path2, _path3, _path4, _path5, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2027 17.9227C23.2027 20.7888 20.8785 23.1122 18.0123 23.1122H7.92799C5.06178 23.1122 2.73766 20.7888 2.73766 17.9227V7.83795C2.73766 4.97247 5.06178 2.64841 7.92799 2.64841H18.0123C20.8785 2.64841 23.2027 4.97247 23.2027 7.83795V17.9227ZM25.6825 7.72428C25.6825 3.55122 22.2998 0.167969 18.126 0.167969H7.81432C3.6405 0.167969 0.257812 3.55122 0.257812 7.72428V18.0363C0.257812 22.2094 3.6405 25.5927 7.81432 25.5927H18.126C22.2998 25.5927 25.6825 22.2094 25.6825 18.0363V7.72428ZM21.1749 6.08949C21.1749 6.90425 20.5145 7.56461 19.7004 7.56461C18.8856 7.56461 18.2252 6.90425 18.2252 6.08949C18.2252 5.27472 18.8856 4.61502 19.7004 4.61502C20.5145 4.61502 21.1749 5.27472 21.1749 6.08949Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.53125 12.2422H24.4135V6.4367C24.4135 3.67527 22.1749 1.4367 19.4135 1.4367H6.53125C3.76983 1.4367 1.53125 3.67527 1.53125 6.43669V12.2422Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9655 19.2344C9.45513 19.2344 6.60938 16.6919 6.60938 12.2426H19.3217C19.3217 17.3275 16.476 19.2344 12.9655 19.2344Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.97 9.06641C10.8637 9.06641 9.15625 10.7739 9.15625 12.8801H16.7837C16.7837 10.7739 15.0762 9.06641 12.97 9.06641Z",
    fill: "#00329A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.97 16.6953C10.8637 16.6953 9.15625 15.0609 9.15625 12.8816H16.7837C16.7837 15.6057 15.0762 16.6953 12.97 16.6953Z",
    fill: "#00329A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.9615,
    cy: 5.89123,
    r: 1.90685,
    fill: "#00329A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInst);
export default __webpack_public_path__ + "static/media/inst.f52fe80845b6c76c067b18f1eb1f4de3.svg";
export { ForwardRef as ReactComponent };